import { camelCase, startCase } from 'lodash'

export const decamelize = (str: string) => startCase(camelCase(str))
